import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { EditDipendentiComponent } from '../modals/edit-dipendenti/edit-dipendenti.component';
import { DipDipendente } from '../objects/DipDipendente';
import { ApiService } from '../services/api.service';
import { LoadingService } from '../services/loading.service';
import { SnackbarService } from '../services/snackbar.service';

@Component({
  selector: 'app-dipendenti',
  templateUrl: './dipendenti.component.html',
  styleUrls: ['./dipendenti.component.scss']
})
export class DipendentiComponent implements OnInit {

  users: DipDipendente[] = [];

  displayedColumns: string[] = ['email', 'password', 'enable', 'actions'];
  dataSource;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private loadingService: LoadingService,
    private apiService: ApiService,
    private dialog: MatDialog,
    private snackBarService: SnackbarService
  ) {
    this.loadingService.showLoading();
    this.getAllUsers();
   }

  ngOnInit(): void {
  }

  getAllUsers() {
    this.apiService.getAllDipendenti()
    .then((users: DipDipendente[]) => {
      console.log(users)
      this.loadingService.hideLoading();
      this.dataSource = new MatTableDataSource(users);
      this.dataSource.paginator = this.paginator;      
    })
  }

  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource(this.users);
    this.dataSource.paginator = this.paginator;
  }

  addElement() {
    let user: DipDipendente = new DipDipendente();
    const dialogRef = this.dialog.open(EditDipendentiComponent, {
      width: '80%',
      // data: {name: this.name, animal: this.animal}
      data: user
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAllUsers();
    });
  }

  editElement(user: DipDipendente){
    const dialogRef = this.dialog.open(EditDipendentiComponent, {
      width: '80%',
      // data: {name: this.name, animal: this.animal}
      data: user
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getAllUsers();
    });
  }

  deleteElement(user: DipDipendente){
    if(confirm('Sei sicuro? Azione irreversibile, le missioni di questo utente saranno resettate')){
      this.loadingService.showLoading();
      this.apiService.deleteDipendente(user)
      .then(x => {
        if(x){
          this.getAllUsers();
          this.snackBarService.openSnackBar("Operazione eseguita con successo")
        } else {
          this.snackBarService.openSnackBar("Ops, qualcosa è andato storto si prega di riprovare")
        }
        this.loadingService.hideLoading();
      })
    }
  }

}
